import React from 'react';
import { Col, Form, Row, Typography, Select } from 'antd';
import uuid from 'react-uuid';
import { useTranslation } from 'react-i18next';
import Helpers from 'helpers';

const { Option, OptGroup } = Select;

const renderShopOptions = (shops = []) =>
  shops.map((shop) => (
    <Option key={uuid()} value={shop.value}>
      {shop.title}
    </Option>
  ));

const ShopSection = ({ shops = [], inactiveShops = [], isView }) => {
  const { t } = useTranslation();

  return (
    <Row gutter={24}>
      <Col span={6}>
        <Typography.Title level={3}>{t('Shop')}</Typography.Title>
      </Col>
      <Col span={6}>
        <Form.Item label={t('Insegna')} name='company_id'>
          <Select
            {...Helpers.addSearchProps()}
            placeholder={t('Insegna')}
            disabled={isView}
          >
            <Option value=''>{t('Selezioni opzione')}</Option>
            {inactiveShops.length ? (
              <>
                <OptGroup key='active' label={t('Insegne attive')}>
                  {renderShopOptions(shops)}
                </OptGroup>
                <OptGroup key='inactive' label={t('Insegne non attive')}>
                  {renderShopOptions(inactiveShops)}
                </OptGroup>
              </>
            ) : (
              renderShopOptions(shops)
            )}
          </Select>
        </Form.Item>
      </Col>
    </Row>
  );
};

export default React.memo(ShopSection);
